import * as React from 'react';
import { InputBaseModel, NodeBaseModel } from '../models';

export default (node: NodeBaseModel | undefined, setFormFieldValue: (input: InputBaseModel) => void) => {
    const setNodeFormFieldValues = React.useCallback(
        (nodeToProcess: NodeBaseModel) => {
            nodeToProcess.inputs.forEach(setFormFieldValue);
            nodeToProcess.childNodes.forEach(setNodeFormFieldValues);
        },
        [setFormFieldValue]
    );

    React.useEffect(() => {
        if (!node) {
            return;
        }

        setNodeFormFieldValues(node);
    }, [node, node?.inputs, node?.childNodes, setNodeFormFieldValues]);
};
